const firstDefined = (sources, ...keys) => {
  for (const source of sources) {
    for (const key of keys) {
      if (source?.[key] !== null && source?.[key] !== undefined) {
        return source[key];
      }
    }
  }
  return null;
};

export const getZoneIdentity = (switches, deletedPanels) => {
  const sources = [
    ...(switches ?? []).flat().filter(Boolean),
    ...(deletedPanels ?? []).filter(Boolean),
  ];

  return {
    longitude: firstDefined(sources, 'longitude'),
    latitude: firstDefined(sources, 'latitude'),
    zone_id: firstDefined(sources, 'zoneId', 'zone_id'),
  };
};
